import * as styles from "./ComboboxLabel.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxLabelProps } from "./Combobox.types";

export function ComboboxLabel({
  className,
  ...props
}: ComboboxLabelProps): JSX.Element {
  return (
    <BaseCombobox.Label
      data-slot="combobox-label"
      className={clsx(styles.label, className)}
      {...props}
    />
  );
}
